const SessionStorageServices = (() => {
    const storage = window.sessionStorage;
    const identityObjName = `${process.env.REACT_APP_CARRIER_ID}.${window.location.host}.identity`;

    const _setIdentity = (uid, identity) => {
        storage.setItem(`${identityObjName}.${uid}`, identity);
    };

    const _getIdentity = (uid) => {
        return storage.getItem(`${identityObjName}.${uid}`);
    };

    const _clearIdentity = (uid) => {
        storage.removeItem(`${identityObjName}.${uid}`);
    };

    return {
        setIdentity: _setIdentity,
        getIdentity: _getIdentity,
        clearIdentity: _clearIdentity,
    };
})();

export default SessionStorageServices;
